import {
    List,
    Datagrid,
    FunctionField,
    ListProps,
    TextField,
    DateField,
    CreateButton,
    ExportButton,
    FilterButton,
    TopToolbar,
    Button,
    sanitizeListRestProps,
    Pagination
} from 'react-admin'
import { Record, useTranslate, useNotify } from 'ra-core'
import datagridStyles from '../../layout/styles/datagridStyles'
import SchoolClassListFilters from './SchoolClassListFilters'
import DatagridPublishedColumnContent from '../../components/common/DatagridPublishedColumnContent'
import BulkActionButtons from 'components/common/BulkActionButtons'
import { CustomDatagridBody } from 'components/common/CustomDatagridBody'
import { DEFAULT_PER_PAGE, ROWS_PER_PAGE } from '../../globals'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import { useState } from 'react'
import UploadDialog from '../../components/common/UploadDialog'
import { useSchoolsImportSchoolClassesMutation } from '../../apollo/upload/mutations/SchoolsImportSchoolClasses.generated'

const ListActions = (props) => {
    const t = useTranslate()
    const { className, maxResults, forceUpdate, ...rest } = props
    const [openDialog, setOpenDialog] = useState(false)
    const [uploadSchoolClasses] = useSchoolsImportSchoolClassesMutation()
    const notify = useNotify()

    const handleUpload = (files) => {
        if (files?.[0]) {
            uploadSchoolClasses({
                variables: {
                    file: files?.[0]
                }
            })
                .then(() => {
                    setOpenDialog(false)
                    forceUpdate()
                })
                .catch((error) => notify(error.message, 'error'))
        }
    }

    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            <FilterButton />
            <CreateButton />
            <ExportButton />
            <Button
                onClick={() => {
                    setOpenDialog(true)
                }}
                label={t('manager.resources.schoolClass.upload')}
            >
                <CloudUploadIcon />
            </Button>
            <UploadDialog
                open={openDialog}
                handleClose={() => setOpenDialog(false)}
                acceptedFiles={[
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                ]}
                handleSave={handleUpload}
                filesLimit={1}
            />
        </TopToolbar>
    )
}

const SchoolClassList = (props: ListProps) => {
    const RESOURCE = 'SchoolClass'

    const datagridClasses = datagridStyles()
    const translate = useTranslate()

    const forceUpdate = () => window.location.reload()

    return (
        <List
            {...props}
            basePath={`/${RESOURCE}`}
            resource={RESOURCE}
            sort={{ field: 'name', order: 'DESC' }}
            perPage={DEFAULT_PER_PAGE}
            filter={props.filter}
            filters={SchoolClassListFilters}
            bulkActionButtons={<BulkActionButtons />}
            actions={props.filter ? <></> : <ListActions forceUpdate={forceUpdate} />}
            pagination={<Pagination rowsPerPageOptions={ROWS_PER_PAGE} />}
        >
            <Datagrid body={<CustomDatagridBody />} classes={datagridClasses} rowClick="edit">
                <TextField source="name" label={translate('manager.resources.schoolClass.name')} />
                <FunctionField
                    source="school"
                    label={translate('manager.resources.schoolClass.school')}
                    sortable={false}
                    render={(record?: Record | undefined) =>
                        `${record?.school?.ajat_id} | ${record?.school?.name}`
                    }
                />
                <FunctionField
                    source="school"
                    label={translate('manager.resources.schoolClass.year')}
                    sortable={false}
                    render={(record?: Record | undefined) => record?.year?.name}
                />
                <FunctionField
                    source="active"
                    label={translate('manager.resources.general.status')}
                    render={(record?: Record | undefined) => (
                        <DatagridPublishedColumnContent record={record} />
                    )}
                />
                <TextField
                    source="priority"
                    label={translate('manager.resources.schoolClass.priority')}
                />
                <DateField
                    label={translate('manager.resources.general.last_updated')}
                    source="updated_at"
                    showTime
                />
            </Datagrid>
        </List>
    )
}
export default SchoolClassList
